// Specific definitions / labels for content areas throughout the app.
// Currently mostly used to reference uses of ContentSection.jsx, but can
// be expanded to refer to any component that can be considered a distinct
// content area. Can be used as metadata for analytics log events

export const GlobalContentSections = Object.freeze({
  SIMILAR_ARTISTS: 'similar_artists',
} as const);

export const BackstageContentSections = Object.freeze({
  CONTROL_BAR: 'control_bar',
  HEADER: 'header',
  HERO_IMAGE: 'hero_image',
  TRACK_LIST: 'track_list',
  COPYRIGHT: 'copyright',
  LYRICS: 'lyrics',
  CREDITS: 'credits',
  SONG_FEATURES: 'song_features',
  SIMILAR_SONGS: 'similar_songs',
  STATION_CREATED_FROM: 'station_created_from',
  SONGS_ON_STATION: 'songs_on_station',
  ARTISTS_ON_STATION: 'artists_on_station',
  FIND_SONG: 'find_song',
  ADD_SIMILAR_SONGS: 'add_similar_songs',
  TOP_SONGS: 'top_songs',
  CURATOR_STATIONS: 'stations_by',
  CURATOR_PLAYLISTS: 'playlists_by',
  PLAYABLE_ROW_GRID: 'playable_row_grid',
  ARTIST_RADIO: 'artist_radio',
  LATEST_RELEASE: 'latest_release',
  TOP_ALBUMS: 'top_albums',
  SIMILAR_ARTISTS: 'similar_artists',
  EPISODE_LIST: 'episode_list',
  METADATA_MORE: 'metadata_more',
  METADATA_CONTINUE: 'metadata_continue',
  THUMBED_EPISODES: 'thumbed_episodes',
  CATEGORY_MORE: 'category_more',
  DESCRIPTION: 'description',
  SOCIAL_LINKS: 'social_links',
  SIMILAR: 'similar',
  ARTIST_BACKSTAGE_FEATURED_CONTENT: 'artist_backstage_featured_content',
} as const);

export const CollectionContentSections = Object.freeze({
  RECENTLY_PLAYED_CAROUSEL: 'recently_played_carousel',
} as const);

export const ContentSections = Object.freeze({
  ...BackstageContentSections,
  ...CollectionContentSections,
} as const);
